export const SORT_ORDERS = {
  asc: {
    key: 'asc',
    multiplier: 1,
  },
  desc: {
    key: 'desc',
    multiplier: -1,
  },
}